import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const LanguageSwitcherSkeleton = (): ReactElement => {
  return (
    <Skeleton
      title={{
        style: {
          width: 53,
          margin: '0 12px 0 0',
          height: 38,
          borderRadius: '0 4px 4px 0'
        }
      }}
      paragraph={false}
      active
    />
  );
};
